module.exports = __webpack_public_path__ + "static/media/auth-page.f44f6c9a.jpg";